import { withHook } from 'utils/withHook';
import { useCompetitionsFeedItemState } from 'containers/CompetitionsFeedItem/logic/useCompetitionsFeedItemState';
import { CompetitionsFeedItemView } from 'containers/CompetitionsFeedItem/view/CompetitionsFeedItemView';

export const CompetitionsFeedItem = withHook(useCompetitionsFeedItemState)(
  CompetitionsFeedItemView
);
